

const FAQItem = ({ data, show, setShow },) => {
  return (
    <>
      {show == data.id ? (
        <div className="faq-q-a">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-white">
              {data.question}
            </div>
            <a onClick={() => setShow(false)}>
              <img alt="ob-image" src="/assets/images/minus.webp" width={25} />
            </a>
          </div>
          <div className="text-white mt-2" style={{ fontSize: 13 }}>
            {" "}
            {/* {data.answer} */}
            <p className="text-white" dangerouslySetInnerHTML={{ __html: data.answer }}></p>
          </div>
        </div>

      ) : (
        <div className="faq-q">
          <div className="text-white">
            {data.question}
          </div>
          <a onClick={() => setShow(data.id)}>
            <img alt="ob-image" src="/assets/images/plus.webp" width={25} />
          </a>
        </div>
      )}
    </>
  );
};

export default FAQItem;
